<mat-form-field>
<mat-label>User ID</mat-label>
<input #input matInput [formControl]="myControl" cdkFocusInitial [matAutocomplete]="auto" [value]="userId" (input)="filter()" (focus)="filter()"/>
<mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
    @for (option of filteredOptions; track option) {
      <mat-option [value]="option">{{option}}</mat-option>
    }
</mat-autocomplete>
</mat-form-field>